const IconTikTok = (): JSX.Element => {
  return (
    <>
      <g>
        <path
          d="M22.2,10v-4.1c-5.4-.2-5.6-5.1-5.6-5.6h0s-4.2,0-4.2,0v16.1c0,1.8-1.5,3.3-3.3,3.3-1.8,0-3.3-1.5-3.3-3.3s1.5-3.3,3.3-3.3c.3,0,.6,0,1,.1v-4.3c-4.1-.5-7.8,2.4-8.4,6.4-.5,4.1,2.4,7.8,6.4,8.4,4.1.5,7.8-2.4,8.4-6.4,0-.4,0-.9,0-1.3v-7.9c1.9,1.8,5.6,1.9,5.6,1.9"
          fill="currentColor"
        />
        <path
          d="M9.2,9.1c-3.6,0-6.7,2.7-7.2,6.3-.2,1.9.3,3.8,1.4,5.3,1.2,1.5,2.9,2.5,4.8,2.8.3,0,.6,0,.9,0,3.6,0,6.7-2.7,7.2-6.3,0-.4,0-.8,0-1.2v-7.9c0,0,0-.2.1-.2,0,0,.2,0,.3,0,1.6,1.4,4.3,1.8,5.2,1.8v-3.6c-5-.3-5.5-4.6-5.5-5.6h-3.7v15.8c0,1.9-1.6,3.5-3.5,3.5s-1.8-.4-2.5-1c-.7-.7-1-1.6-1-2.5,0-1.9,1.6-3.5,3.5-3.5s.5,0,.7,0v-3.7c-.2,0-.5,0-.7,0ZM9.2,24c-.3,0-.7,0-1,0-2-.3-3.9-1.3-5.1-2.9-1.3-1.6-1.8-3.7-1.5-5.7.5-3.8,3.8-6.7,7.6-6.7s.7,0,1,0c.1,0,.2.1.2.2v4.3c0,0,0,.1,0,.2,0,0-.1,0-.2,0-.3,0-.6-.1-.9-.1-1.7,0-3.1,1.4-3.1,3.1s.3,1.6.9,2.2c.6.6,1.3.9,2.2.9,1.7,0,3.1-1.4,3.1-3.1V.2c0-.1.1-.2.2-.2h4.2c.1,0,.2.1.2.2h0c0,.3,0,5.2,5.3,5.4.1,0,.2.1.2.2v4.1c0,0,0,.1,0,.2,0,0-.1,0-.2,0-.1,0-3.3-.2-5.3-1.6v7.5c0,.4,0,.8,0,1.3-.5,3.8-3.8,6.7-7.6,6.7"
          fill="currentColor"
        />
      </g>
    </>
  );
};

export default IconTikTok;
